import {tokens} from '@pleo-io/telescope'
import React from 'react'
import styled, {keyframes} from 'styled-components'

import {BackgroundWrapper} from '@helios/shared/styles/grid'
import {Text} from '@helios/shared/styles/typography'

interface Props {
    items: string[]
}

export const RotatingBanner: React.FC<Props> = ({items}) => {
    const itemsGroup = (
        <ConveyorBelt>
            {items.map((item, i) => (
                <Spacer key={i}>
                    <Text variant="paragraph-large">{item}</Text>
                </Spacer>
            ))}
        </ConveyorBelt>
    )

    // We render a 2nd chunk of items so they can slide into view as the first chunk slides out of view
    return <ScrollableContainer color="pink">{[itemsGroup, itemsGroup]}</ScrollableContainer>
}

const ScrollableContainer = styled(BackgroundWrapper)`
    display: flex;
    width: 100%;
    overflow: hidden;
`

const rotate = keyframes`
    0% {
        transform: translateX(0);
    }

    100% {
        transform: translateX(-100%);
    }
`

const ConveyorBelt = styled.ul`
    display: flex;
    justify-content: space-around;
    flex-shrink: 0;
    min-width: 100vw;
    padding: 0;
    margin: 0;
    list-style: none;
    animation-name: ${rotate};
    animation-duration: 25s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;

    .no-touch ${ScrollableContainer}:hover & {
        animation-play-state: paused;
    }
`

const Spacer = styled.li`
    padding: ${tokens.spacing12} ${tokens.spacing28};
    white-space: nowrap;
`
